/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://7fk7w4rsq9.execute-api.us-east-1.amazonaws.com/msprod",
            "region": "us-east-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://76dfut6kg5bvlazampi2bb7izm.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-ikjfrnr3vjccxcayvp72rjlk4e",
    "aws_cognito_identity_pool_id": "us-east-1:9470c98a-5442-4f16-aa8f-23d8f92f798a",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_2XcDsNZMQ",
    "aws_user_pools_web_client_id": "3udtbsg1c22chfdeqt5elena5t",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": "12",
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
